import { Injectable } from '@angular/core';

@Injectable()
export class DateTimeService {
	public dateTime = 'MMM d, y HH:mm Z';
	public date = 'MMM d, y';
	public time = 'HH;mm Z';
  private TIME_FORMAT_KEY = 'user_time_format';

	constructor() {
		const dateTime = localStorage.getItem('RapidShip:date-time');
		const date = localStorage.getItem('RapidShip:date');
		const time = localStorage.getItem('RapidShip:time');

		if (dateTime) {
			this.dateTime = dateTime;
		}

		if (date) {
			this.date = date;
		}

		if (time) {
			this.time = time;
		}
	}

	getDateTime() {
		return this.dateTime;
	}

	getDate() {
		return this.date;
	}

	getTime() {
		return this.time;
	}

	setDateTime(data) {
		this.dateTime = data;
		localStorage.setItem('RapidShip:date-time', data);
	}

	setDate(data) {
		this.date = data;
		localStorage.setItem('RapidShip:date', data);
	}

	setTime(data) {
		this.time = data;
		localStorage.setItem('RapidShip:time', data);
	}

	processDateTimeFormat(date, time) {
		let dateString, timeString, dateTimeString;

		if (date === 'yyyy-mm-dd') {
			dateString = 'yyyy-LL-dd';
		} else if (date === 'ddd mm/dd/yy') {
			dateString = 'EEE MM/dd/yy';
		} else if (date === 'mm/dd/yy') {
			dateString = 'MM/dd/yy';
		} else {
			dateString = 'MM/dd/yyyy';
		}

		if (time === 'h:nn AM/PM') {
			timeString = 'h:mm a';
		} else {
			timeString = 'hh:mm';
		}

		dateTimeString = dateString + ' ' + timeString;

		this.setDate(dateString);
		this.setTime(timeString);
		this.setDateTime(dateTimeString);
	}

  getTimeFormat(): 12 | 24 {
    return Number(localStorage.getItem(this.TIME_FORMAT_KEY)) as 12 | 24;
  }

  updateTimeFormat(format: 12 | 24): void {
    localStorage.setItem(this.TIME_FORMAT_KEY, `${format}`);
  }
}
